<template>
  <v-row dense class="pb-3">
    <v-col cols="4">
      <v-autocomplete
        v-model="client"
        :items.sync="filteredClients"
        :disabled="loading"
        :search-input.sync="search"
        clearable
        no-filter
        hide-no-data
        hide-selected
        hide-details
        dense
        label="Фільтр по клієнтам"
        placeholder="Введіть назву клієнта"
        class="mr-1 dense"
        outlined
        return-object
        item-text="title"
        item-value="id"
        append-icon="search"
        @input="setFilter"
        @click:append="clientId && (openModal = true)"
      />
      <ModalWindow
        :id="clientId"
        v-model="openModal"
        component-name="Client"
        @close="openModal = false"
      />
    </v-col>
    <v-col cols="4">
      <ManagerSelect v-model="manager" :label="label" @input="setFilter" />
    </v-col>
    <v-col cols="2">
      <DatePicker
        v-model="date"
        default-value
        :filled="false"
        label="На дату(включно)"
        @input="setFilter"
      />
    </v-col>
    <v-col cols="2">
      <v-switch
        v-model="onlyNegative"
        class="ml-2 mb-n6"
        :disabled="loading"
        color="green"
        label="Тільки негативні"
        @change="setFilter"
      />
    </v-col>
  </v-row>
</template>

<script>
import ManagerSelect from "@/views/catalogs/managers/ManagerSelect.vue";
import DatePicker from "@/components/story/DatePicker";

export default {
  components: {
    DatePicker,
    ManagerSelect,
    ModalWindow() {
      return import("@/components/ModalWindow.vue");
    },
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    onlyNegative: false,
    client: null,
    manager: null,
    clearable: true,
    label: "Фільтр по менеджерам",
    openModal: false,
    clients: [],
    date: "",
    search: null,
  }),
  computed: {
    clientId() {
      return this.client ? this.client.id : null;
    },
    filteredClients() {
      let clients = this.clients;
      if (this.search) {
        clients = clients.filter((i) =>
          i.title.toUpperCase().includes(this.search.toUpperCase())
        );
      }
      return clients;
    },
  },
  watch: {
    items(val) {
      this.clients = val;
    },
  },
  methods: {
    setFilter() {
      return this.$emit("input", {
        onlyNegative: this.onlyNegative,
        client: this.client,
        manager: this.manager,
        date: this.date,
      });
    },
  },
};
</script>
